/**
 * Re-exported from `@hrms/shared` — the parsing logic has zero DOM dependency, so it moved there
 * to stop drifting from `apps/mobile`'s identical copy. `newIdempotencyKey` stays local: it's a
 * `crypto.randomUUID()` call, not error parsing, and doesn't belong in a shared error-handling
 * module.
 */
export { apiErrorStatus, apiErrorMessage } from '@hrms/shared';

/** A fresh key per mutation attempt — CLAUDE.md invariant 10, every mutating endpoint needs one. */
export function newIdempotencyKey(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `idem-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
